import PropTypes from "prop-types";

import { cn } from "@/lib/utils";

// Avatar-style circular image with an optional state overlay
// (loading/error tint). Tailwind-only — no MUI primitives.

const State = {
  Loading: "loading",
  Error: "error",
  Success: "success",
};

UserIcon.propTypes = {
  src: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  state: PropTypes.oneOf(Object.values(State)),
  onClick: PropTypes.func,
};

function UserIcon({ src, width, height, state, onClick }) {
  // Tint mirrors the original MUI-era overlay: white-out while loading,
  // red wash on error, transparent on success.
  const overlay =
    state === State.Loading
      ? "bg-white/60"
      : state === State.Error
      ? "bg-red-500/60"
      : null;

  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-full",
        onClick ? "cursor-pointer" : "cursor-inherit",
      )}
      style={{ width, height }}
    >
      <img
        src={src}
        onClick={onClick}
        alt=""
        className="size-full object-cover"
      />
      {overlay ? (
        <div className={cn("absolute inset-0", overlay)} aria-hidden />
      ) : null}
    </div>
  );
}

export { UserIcon, State };
